import mod from "-!./sendConvocatoria.js?vue&type=script&lang=js&"; export default mod; export * from "-!./sendConvocatoria.js?vue&type=script&lang=js&"